/**
 * @fileoverview Supabase Client - Database and authentication singleton
 * 
 * @description
 * Auto-generated Supabase client configuration. This file provides the
 * primary interface to Supabase services throughout the application.
 * 
 * ## DO NOT EDIT DIRECTLY
 * This file is automatically generated. Manual edits will be overwritten.
 * 
 * ## Usage
 * ```ts
 * import { supabase } from "@/integrations/supabase/client";
 * 
 * // Database queries
 * const { data } = await supabase.from('profiles').select('*');
 * 
 * // Authentication
 * const { data: { user } } = await supabase.auth.getUser();
 * 
 * // Edge functions
 * const { data } = await supabase.functions.invoke('my-function');
 * 
 * // Realtime subscriptions
 * supabase.channel('changes').on('postgres_changes', ...).subscribe();
 * ```
 * 
 * ## Configuration
 * - **URL**: Project endpoint (mncnvbdlzbrodqspapmo.supabase.co)
 * - **Anon Key**: Public/anonymous access key
 * - **Auth Storage**: localStorage with auto-refresh
 * 
 * @module integrations/supabase/client
 * @see {@link https://supabase.com/docs/reference/javascript/introduction}
 */

// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mncnvbdlzbrodqspapmo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1uY252YmRsemJyb2Rxc3BhcG1vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAyMTM1NDgsImV4cCI6MjA3NTc4OTU0OH0.nCPwy1iCxQBDsiqDZsa8RQuC8qXhJ5FHsyh7vetrCws";

/**
 * Supabase client singleton
 * 
 * Pre-configured with:
 * - localStorage for session persistence
 * - Automatic token refresh
 * - TypeScript database types
 * 
 * @example
 * ```ts
 * // Query with types
 * const { data } = await supabase
 *   .from('profiles')
 *   .select('id, full_name, avatar_url')
 *   .single();
 * 
 * // data is typed as Database['public']['Tables']['profiles']['Row']
 * ```
 */
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

/** Supabase project URL for edge function calls */
export const SUPABASE_PROJECT_URL = SUPABASE_URL;